/* global React, Icon, Modal, Button, Input, toast, fmt, t */

function AiLiquidityBufferControl({ bufferInfo, onSaved }) {
  const [open, setOpen] = React.useState(false);
  const [mode, setMode] = React.useState('automatic');
  const [amount, setAmount] = React.useState('');
  const [saving, setSaving] = React.useState(false);
  const info = bufferInfo || {};
  const effectiveAmount = Number(info.amount) || Number(info.recommendedAmount) || 0;
  const recommendedAmount = Number(info.recommendedAmount) || effectiveAmount;

  const openEditor = () => {
    const nextMode = info.mode === 'custom' ? 'custom' : 'automatic';
    setMode(nextMode);
    setAmount(String(nextMode === 'custom' ? (Number(info.amount) || '') : (recommendedAmount || '')));
    setOpen(true);
  };

  const save = async () => {
    if (!window.PlummeBackend?.saveAiAdvisorLiquidityBuffer) {
      toast(t('adv.buffer.unavailable'), 'error');
      return;
    }
    const numericAmount = Math.round(window.PlummeMoneyInput.number(amount, 0));
    if (mode === 'custom' && (!Number.isFinite(numericAmount) || numericAmount <= 0)) {
      toast(t('adv.buffer.invalid'), 'warning');
      return;
    }
    setSaving(true);
    try {
      await window.PlummeBackend.saveAiAdvisorLiquidityBuffer({ mode, amount: numericAmount });
      setOpen(false);
      await onSaved?.();
      toast(t('adv.buffer.saved'), 'success');
    } catch (error) {
      toast(error?.message || t('adv.buffer.saveFailed'), 'error');
    } finally {
      setSaving(false);
    }
  };

  return <React.Fragment>
    <button
      type="button"
      className="aii-buffer-chip"
      onClick={openEditor}
      title={t('adv.buffer.edit')}
      aria-label={t('adv.buffer.editAria', { amount: fmt(effectiveAmount) })}
      data-help-title={t('adv.buffer.title')}
      data-help={t('adv.help.buffer')}
    >
      <span>{info.mode === 'custom' ? t('adv.buffer.chosen') : t('adv.buffer.recommended')}</span>
      <b>{fmt(effectiveAmount)}</b>
      <Icon name="settings" size={15} />
    </button>

    <Modal
      open={open}
      portal
      onClose={() => !saving && setOpen(false)}
      max={500}
      title={t('adv.buffer.title')}
      footer={<React.Fragment>
        <Button variant="ghost" disabled={saving} onClick={() => setOpen(false)}>{t('common.cancel')}</Button>
        <Button icon="check" disabled={saving} onClick={save}>{saving ? t('adv.buffer.saving') : t('common.save')}</Button>
      </React.Fragment>}
    >
      <div className="aii-buffer-options" role="radiogroup" aria-label={t('adv.buffer.title')}>
        <button type="button" role="radio" aria-checked={mode === 'automatic'} className={'aii-buffer-option' + (mode === 'automatic' ? ' selected' : '')} onClick={() => setMode('automatic')}>
          <span className="aii-buffer-radio" />
          <span><b>{t('adv.buffer.auto')}</b><small>{t('adv.buffer.autoHelp', { amount: fmt(recommendedAmount) })}</small></span>
        </button>
        <button type="button" role="radio" aria-checked={mode === 'custom'} className={'aii-buffer-option' + (mode === 'custom' ? ' selected' : '')} onClick={() => setMode('custom')}>
          <span className="aii-buffer-radio" />
          <span><b>{t('adv.buffer.custom')}</b><small>{t('adv.buffer.customHelp')}</small></span>
        </button>
      </div>

      {mode === 'custom' && <label className="aii-buffer-input">
        <span>{t('adv.buffer.amount')}</span>
        <Input type="number" min="1" step="1000" inputMode="decimal" value={amount} onChange={(event) => setAmount(event.target.value)} autoFocus />
      </label>}

      <div className="aii-buffer-basis">
        <b>{t('adv.buffer.basisTitle')}</b>
        <span data-help-title={t('adv.buffer.basisMinimum')} data-help={t('adv.help.bufferMinimum')}>{t('adv.buffer.basisMinimum')}: <strong>{fmt(info.basis?.minimum || 50000)}</strong></span>
        <span data-help-title={t('adv.buffer.basisMonthlyCosts')} data-help={t('adv.help.monthlyCosts')}>{t('adv.buffer.basisMonthlyCosts')}: <strong>{fmt(info.basis?.monthlyCosts || 0)}</strong></span>
        <span data-help-title={t('adv.buffer.basisTax')} data-help={t('adv.help.taxReserve')}>{t('adv.buffer.basisTax')}: <strong>{fmt(info.basis?.taxReserve || 0)}</strong></span>
        <span data-help-title={t('adv.buffer.basisVat')} data-help={t('adv.help.vatDue')}>{t('adv.buffer.basisVat')}: <strong>{fmt(info.basis?.vatDue || 0)}</strong></span>
        <small>{t('adv.buffer.basisHelp')}</small>
      </div>
    </Modal>
  </React.Fragment>;
}

Object.assign(window, { AiLiquidityBufferControl });
window.dispatchEvent?.(new CustomEvent('plumme-page-registered', { detail: { pages: ['AiLiquidityBufferControl'] } }));
